import { createContext } from "react";

import type { UseThemeType } from "./types";

export const SizeContext = createContext<UseThemeType["sizes"] | null>(null);
